import { connect } from 'react-redux';
import { pushUnsubscribeModal } from '../../redux/consumer/actions';
var mapDispatchToProps = function (dispatch, _a) {
    var deviation = _a.deviation;
    return ({
        unsubscribe: function () { return dispatch(pushUnsubscribeModal(deviation)); },
    });
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=ManageTier.container.js.map